@use '../../../sass/theme';
@use '../../../sass/form-control-mixins';

:host {

  $sliderWidth: 55px;
  $sliderWidth--sm: 48px;
  $sliderWidth--lg: 60px;

  display: block;

  .jui-checkbox {
    font-family: var(--jui-font-family);
    align-items: center;

    &--flex {
      display: flex;
    }

    &__toggle {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      -webkit-transition: .4s;
      transition: .4s;
      border-radius: 34px;
      width: $sliderWidth;

      &--sm {
        width: $sliderWidth--sm;
        &:before {
          position: absolute;
          content: "";
          height: 18px;
          width: 18px;
          bottom: 1px;
          left: 2px;
          background-color: white;
          -webkit-transition: .4s;
          transition: .4s;
          border-radius: 50%;
        }
      }

      &--md {
        &:before {
          position: absolute;
          content: "";
          height: 22px;
          width: 22px;
          bottom: 2px;
          left: 3px;
          background-color: white;
          -webkit-transition: .4s;
          transition: .4s;
          border-radius: 50%;
        }
      }

      &--lg {
        width: $sliderWidth--lg;
        &:before {
          position: absolute;
          content: "";
          height: 26px;
          width: 26px;
          bottom: 4px;
          left: 4px;
          background-color: white;
          -webkit-transition: .4s;
          transition: .4s;
          border-radius: 50%;
        }
      }

      &-text {
        position: relative;
        left: $sliderWidth;
        white-space: nowrap;

        &--sm {
          left: $sliderWidth--sm;
          top: 1px;
        }

        &--md {
          top: 2px;
        }

        &--lg {
          left: $sliderWidth--lg;
          top: 4px;
        }
      }

      &-slider {
        position: relative;
        display: flex;
        flex-direction: row;

        &--sm {
          height: 20px;
        }

        &--md {
          height: 26px;
        }

        &--lg {
          height: 34px;
        }
      }

      &-container {
        display: flex;
        flex-direction: column;
      }

      &-wrapper {
        position: relative;
        display: flex;
      }

      &--checked {
        background-color: var(--jui-primary-color);

        &:before {
          transform: translateX(27px);
        }
      }
    }

    &__label {
      margin-left: var(--jds-space-xs);

      &--md {
        font-size: var(--jui-input-fs);
      }

      &--sm {
        font-size: var(--jui-input-fs-sm)
      }

      &--lg {
        font-size: var(--jui-input-fs-lg)
      }

      &--disabled {
        @include form-control-mixins.form-label-disabled;
      }

      &--toggle {
        position: relative;

        input {
          opacity: 0;
          width: 0;
          height: 0;
        }
      }
    }

    &__input {
      &--md {
        transform: scale(1.25);
      }

      &--lg {
        transform: scale(1.5);
      }
    }
  }
}
